module.exports = __webpack_public_path__ + "static/work-1212gateway-ea527695c4ffa4ebf0d1fb54eb1b792e.jpg";